import React from 'react'
import IncomeHeader from '../../IncomeHeader'
import InputBox from '../../common/InputBox'
import Select from '../../../../commons/Select'

// TODO: These variables should be moved somewhere else and be shared as they are used in other components as well
let years = [{ value: '0', label: '0' }];
let months = [{ value: '0', label: '0' }];
for (let i = 1; i < 4; i++) {
  years.push( { value: i.toString(), label: i.toString() } )
}
years.push( { value: '>3', label: '>3' } )

for (let i = 1; i < 13; i++) {
  months.push( { value: i.toString(), label: i.toString() } )
}

class SocialSecurity extends React.Component {
  state = {
    frequency: this.props.income.frequency || 'yearly',
  }

  componentDidMount() {
    this.props.onChange( this.state )
  }

  handleAmount = (e) => {
    const value = e.target.value.replace(/,/g, '')
    const amount = value ? parseInt(value) : null
    this.props.onChange({ amount })
  }

  handleFrequency = (frequency) => {
    this.props.onChange({ frequency })
  }

  handlePeriodYears = (periodYears) => {
    this.props.onChange({ periodYears })
  }

  handlePeriodMonths = (periodMonths) => {
    this.props.onChange({ periodMonths })
  }

  render() {
    const {
      iconName,
      title,
      income,
      errors,
    } = this.props

    const {
      amount,
      frequency,
      periodYears,
      periodMonths,
    } = income

    return(
      <div className='income'>
        <IncomeHeader iconName={ iconName }
                      title={ title }
        />

        <InputBox
          label={ `How much do you receive?` }
          labelClass='grey'
          type={ 'SocialSecurity' }
          amount={ amount }
          frequency={ frequency }
          handleAmount={ this.handleAmount }
          handleFrequency={ this.handleFrequency }
          errorMessage={ errors && errors.amount }
          inputMode='numeric'
        />

        <p className='grey smaller mb-1'>How long have you been receiving this for?</p>
        <div className='form-row'>
          <div className='col-6 col-sm-2 pb-2'>
            <Select
              defaultValue={ periodYears || years[0].value }
              onChange={ this.handlePeriodYears }
              options={ years }
            />
          </div>
          <div className='col-3 col-sm-2 align-self-center pb-2'>
            <div className='text-muted'>
              years
            </div>
          </div>
          <div className='col-6 col-sm-2 pb-2'>
            <Select
              defaultValue={ periodMonths || months[0].value  }
              onChange={ this.handlePeriodMonths }
              options={ months }
            />
          </div>
          <div className='col-3 col-sm-2 align-self-center pb-2'>
            <div className='text-muted'>
              months
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SocialSecurity;
